import {Link as RoutedLink} from 'react-router-dom';

import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import styles from './trial-summary-page.module.css';

export function TrialSummaryExpiredState() {
    return (
        <div className={styles['hero-card']}>
            <div className={styles['expired-layout']}>
                <Illustration src='trial-expired' alt='Hourglass' />
                <div className={styles['expired-content']}>
                    <div className={styles['trial-heading']}>
                        <Body isBold={true} color='dark' useDoyle={true}>
                            Your trial has expired.
                        </Body>
                    </div>
                    <Body color='dark'>
                        Choose a plan to continue using Nutshell. Connect with our sales team if you
                        have questions about pricing and tiers.
                    </Body>
                    <Stack spacing={16}>
                        <Link
                            // @ts-expect-error
                            as={RoutedLink}
                            variant='button-primary'
                            size='xlarge'
                            widthFitContent={true}
                            to='/setup/billing/sales'
                        >
                            Upgrade to a paid plan
                        </Link>
                        <Link
                            variant='primary'
                            href='https://www.nutshell.com/contact'
                            newTab={true}
                        >
                            Talk with sales
                        </Link>
                    </Stack>
                </div>
            </div>
        </div>
    );
}
